export default __webpack_public_path__ + "static/media/hht1_timeline.5dff22f1.png";